<template>
  <popup-layout title="카테고리 수정" width="400" :is-show="isShow">
    <template v-slot:content>
      <field-input title="카테고리명">
        <v-text-field
            v-model="modifyData.categoryNm"
            placeholder="입력"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="카테고리 상태">
        <v-select
            v-model="modifyData.useYn"
            :items="ynList"
            item-text="text"
            item-value="value"
            placeholder="선택"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="카테고리 권한">
        <v-select
            v-model="modifyData.useRole"
            :items="useRoleList"
            item-text="text"
            item-value="value"
            placeholder="선택"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="modify">저장</v-btn>
        <v-btn class="button delete" outlined @click="closePopup">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>

<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import _ from "lodash";
import {axiosInstance} from "@/util/AxiosModule";
import constant from "@/util/constant";

export default {
  name: "CategoryModify",
  components: {FieldInput, PopupLayout},
  props: ["isShow", "useRoleList", "selectData"],
  data() {
    return {
      modifyData: {},
      ynList: constant.YN_LIST
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        this.modifyData = _.cloneDeep(this.selectData);
      }
    }
  },
  methods: {
    async modify() {
      if (confirm("수정한 카테고리 정보를 저장하시겠습니까?")) {
        await axiosInstance.patch("/admin/board/category", this.modifyData)
            .then(() => {
              this.showAlert({
                message: "수정이 완료되었습니다.",
                successCallback: () => {
                  this.closePopup();
                  this.$emit("refresh");
                }
              })
            })
      }
    },
    closePopup() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
}
</style>